export const TKeyErrors = {
  ERROR: "ERROR",
  ERROR_REQUIRED: "ERROR_REQUIRED",
  ERROR_REQUIRED_SELECTION: "ERROR_REQUIRED_SELECTION",
  ERROR_INVALID_EMAIL: "ERROR_INVALID_EMAIL",
  ERROR_MEMBER_USER_NOT_FOUND: "ERROR_MEMBER_USER_NOT_FOUND",
  ERROR_MEMBER_ALREADY_IN_COMPANY: "ERROR_MEMBER_ALREADY_IN_COMPANY",
  ERROR_MEMBER_ALREADY_INVITED_COMPANY: "ERROR_MEMBER_ALREADY_INVITED_COMPANY",
  ERROR_MEMBER_ALREADY_EXISTS: "ERROR_MEMBER_ALREADY_EXISTS",
  ERROR_MEMBER_LIMIT_REACHED: "ERROR_MEMBER_LIMIT_REACHED",
  ERROR_INVALID_PHONE: "ERROR_INVALID_PHONE",
  ERROR_INVALID_IMAGE: "ERROR_INVALID_IMAGE",
  ERROR_FILE_TOO_LARGE: "ERROR_FILE_TOO_LARGE",
  ERROR_LOGO_UPLOAD: "ERROR_LOGO_UPLOAD",
  ERROR_TOO_LONG_VALUE: "ERROR_TOO_LONG_VALUE",
  ERROR_TOO_MANY_ITEMS: "ERROR_TOO_MANY_ITEMS",
  ERROR_INVALID_DAY: "ERROR_INVALID_DAY",
  ERROR_INVALID_DATE: "ERROR_INVALID_DATE",
  ERROR_DATE_IN_FUTURE: "ERROR_DATE_IN_FUTURE",
  ERROR_PROSPECT_ACTION_TYPE_LIMIT: "ERROR_PROSPECT_ACTION_TYPE_LIMIT",
  ERROR_INVALID_LINK: "ERROR_INVALID_LINK",
  ERROR_USER_EMAIL_NOT_FOUND: "ERROR_USER_EMAIL_NOT_FOUND",
  ERROR_INVALID_EMAIL_OR_PASSWORD: "ERROR_INVALID_EMAIL_OR_PASSWORD",
  ERROR_SHORT_PASSWORD: "ERROR_SHORT_PASSWORD",
  ERROR_EQUAL_REPEAT_PASSWORD: "ERROR_EQUAL_REPEAT_PASSWORD",
  ERROR_EMAIL_ALREADY_EXISTS: "ERROR_EMAIL_ALREADY_EXISTS",
  ERROR_EMAIL_NOT_VERIFIED: "ERROR_EMAIL_NOT_VERIFIED",
  ERROR_UNAUTHORIZED: "ERROR_UNAUTHORIZED",
  ERROR_CODE_ALREADY_USED: "ERROR_CODE_ALREADY_USED",
} as const;
